export const GEO_STEPS: Record<string, number> = {
  STEP_ACCEPT: 0,
  STEP_SELECT_LOCATION: 1,
  STEP_SUCCESS: 2,
};
